import { IEvent } from "@quest/adapter-interface";
import { Meter, MeterBitmap, SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";
 
export class MoneyHuntingView extends BaseViewBehavior {
    constructor(viewJson: any) {
        super(viewJson);
    }
    protected resize(evt: IEvent): void {
        //do noting will resize as per freegame view
    }

    public createSpineClone(stoneAnimId: any): SpineBase {
        const spine: any = this.createSpine(stoneAnimId);
        return spine;
    }

    public creteMeterClone(stoneAnimId: any): Meter {
        const spine: any = this.createMeter(stoneAnimId);
        return spine;
    }
     public creteMeterBitmapClone(stoneAnimId: any): MeterBitmap {
        const spine: any = this.createMeterBitmap(stoneAnimId);
        return spine;
    }
 
 
 
}